import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-zongshushixin",
  "use": "icon-zongshushixin-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-zongshushixin\"><defs><style type=\"text/css\"></style></defs><path d=\"M950.8352 512H512V0C226.7648 0 0 226.7648 0 512s226.7648 512 512 512 512-226.7648 512-512h-73.1648z\" fill=\"#54a9f7\" p-id=\"8281\" /><path d=\"M943.5648 438.8352h73.1136A496.896 496.896 0 0 0 585.216 7.3216V438.784h358.4z\" fill=\"#54a9f7\" p-id=\"8282\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol